<section class="dynamic-form-intro">
    <p class="dynamic-form-intro__title">{{ 'FORM.INTRO.TITLE' | translate }}</p>
    <img class="dynamic-form-intro__illustration" src="assets/images/form-intro-light.svg" alt="" />
</section>
